import React from 'react'
import { connect } from 'react-redux'
import { formValues } from 'redux-form'
import DateRangeInputContainer from '../../../../components/FormBuilder/DateRangeInput/DateRangeInputContainer'
import { IRoom } from '../../../../models/Room'
import { getUnavailableDatesForRoomWithoutEvent } from '../../../../reducers/bookingCalendar/selectors/rooms'
import { IStore } from '../../../../reducers'
import { EventStatus } from '../../../../models/Event'

const DateRangeContainerWithReservationFields = ({
  dateFrom,
  dateTo,
  _reduxForm,
  children,
  changeDateFrom,
  changeDateTo,
  ...rest
}) => {
  const changeField = (fieldName: string) => (date: Date) =>
    _reduxForm.dispatch(_reduxForm.change(fieldName, date))

  const changeFrom = (date: Date) => {
    changeField('dateFrom')(date)
    changeDateFrom(date)
  }

  const changeTo = (date: Date) => {
    changeField('dateTo')(date)
    changeDateTo(date)
  }

  return (
    <DateRangeInputContainer
      {...rest}
      dateFrom={dateFrom}
      dateTo={dateTo}
      changeDateFrom={changeFrom}
      changeDateTo={changeTo}
      containerStyles={{ zIndex: 1300 }}
    >
      {children}
    </DateRangeInputContainer>
  )
}

const mapUnavailableToProps = (
  state: IStore,
  ownProps: {
    roomId: IRoom['id']
    reservationStatus: EventStatus
  },
) => {
  const props = {
    disabledDays: [],
  }
  if (ownProps.reservationStatus === EventStatus.Canceled) {
    props.disabledDays = []
  } else if (ownProps.roomId) {
    props.disabledDays = getUnavailableDatesForRoomWithoutEvent(state, {
      roomId: ownProps.roomId,
    })
  } else {
    props.disabledDays = [] //getUnavailableDatesForAllRooms(state)
  }

  return props
}

const withUnavailableDates = formValues<any>({
  dateFrom: 'dateFrom',
  dateTo: 'dateTo',
  reservationStatus: 'reservationStatus',
  roomId: 'roomId',
})(connect(mapUnavailableToProps)(DateRangeContainerWithReservationFields))

export default withUnavailableDates
